import { DEFAULT_ALTERNATE_NAME } from 'globalConstants';
import { IconDirectionDown } from 'components/icons';
import { map } from 'lodash';

const QuestionList = () => {
  const questions = [
    <span key={1}>
      1. Bạn quá bận. Vậy làm sao để bán nhà nhanh? Hãy đăng tin hãy quảng cái tại{' '}
      <b>{DEFAULT_ALTERNATE_NAME}</b>
    </span>,
    <span key={2}>
      2. Bạn có biết <b>{DEFAULT_ALTERNATE_NAME}</b> sẽ giúp bạn đăng tin nhanh nhất bằng cách nào
      không?
    </span>,
    <span key={3}>
      3. Đăng tin quảng cáo tại <b>{DEFAULT_ALTERNATE_NAME}</b> có mất phí không? Nếu có thì mất bao
      nhiêu
    </span>,
    <span key={4}>
      4. Nạp tiền vào tài khoản tại <b>{DEFAULT_ALTERNATE_NAME}</b> bằng cách nào? Nạp momo? Nạp
      tiền mặt? Hay nạp bằng hình thức chuyển khoản qua tài khoản ngân hàng có được không?
    </span>,
    <span key={5}>5. Làm sao để biết được bất động sản bạn đang mua giá hợp lý hay không?</span>,
    <span key={6}>
      6. Hãy xem video hướng dẫn bạn đăng ký – đăng nhập, tìm, sửa xóa tại{' '}
      <b>{DEFAULT_ALTERNATE_NAME}</b>
    </span>,
    <span key={7}>
      7. Khi Đăng ký thành viên cao cấp tại <b>{DEFAULT_ALTERNATE_NAME}</b> bạn sẽ được hưởng những
      chính sách ưu đãi gì?
    </span>,
    <span key={8}>
      8. Khi bạn quên Mật khẩu, đổi mật khẩu tại <b>{DEFAULT_ALTERNATE_NAME}</b> thì phải làm sao?
    </span>,
    <span key={9}>
      9. Tôi đăng nhập vào website tại <b>{DEFAULT_ALTERNATE_NAME}</b> bằng tài khoản Google,
      Facebook, Zalo, số điện thoại, email có được không?
    </span>,
  ];

  return (
    <div className='flex w-full flex-col space-y-[24px]'>
      <h1 id='nhung-cau-hoi-thuong-gap' className='text-[24px] font-[600] leading-[30px]'>
        2. Những câu hỏi thường gặp
      </h1>
      <div className='flex w-full flex-col space-y-[12px]'>
        {map(questions, (question, questionIndex) => (
          <span className='flex w-full' key={questionIndex}>
            <IconDirectionDown className='mt-[2px] h-[20px] w-[20px] -rotate-90' />
            {question}
          </span>
        ))}
      </div>
      <div className='h-[5px] w-full border-y border-dashed' />
    </div>
  );
};

export default QuestionList;
